import axios from 'axios';

let installed = false;
let lastSearchKey = '';
let lastSearchAt = 0;
let lastPropertyKey = '';
let lastPropertyAt = 0;

const getToken = () => {
  try { return sessionStorage.getItem('token'); } catch { return null; }
};

const API_URL = process.env.REACT_APP_API_URL || '';

const postEvent = (event_type, payload = {}) => {
  const token = getToken();
  if (!token) return;
  axios.post(`${API_URL}/api/product-events`, {
    event_type,
    ...payload,
  }, {
    headers: { Authorization: `Bearer ${token}` },
  }).catch(() => {});
};

// Eventos disparados de propósito por uma tela, e não deduzidos do tráfego de
// API como os de busca aqui de cima.
//
// `persistente` existe para o checkout: ele leva a pessoa para fora do site com
// window.location, e uma requisição normal é cancelada quando a página começa a
// sair. O `keepalive` faz o navegador entregar mesmo depois da saída — sem ele,
// justamente o evento mais importante do funil se perderia na maioria das vezes.
export function registrarEvento(eventType, metadata = {}, { persistente = false } = {}) {
  const token = getToken();
  if (!token) return;
  const corpo = JSON.stringify({ event_type: eventType, metadata });
  const cabecalho = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };

  if (persistente && typeof fetch === 'function') {
    try {
      fetch(`${API_URL}/api/product-events`, {
        method: 'POST', headers: cabecalho, body: corpo, keepalive: true,
      }).catch(() => {});
      return;
    } catch { /* cai no envio comum abaixo */ }
  }
  postEvent(eventType, { metadata });
}

const normalizedUrl = (config) => {
  try {
    const raw = String(config?.url || '');
    const base = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
    return new URL(raw, base);
  } catch {
    return null;
  }
};

const hasMeaningfulSearch = (params) => {
  const ignored = new Set([
    'page', 'limit', 'ordenarPor', 'excluirParteIdeal', 'excluirSustado', 'situacao'
  ]);
  for (const [key, value] of params.entries()) {
    if (ignored.has(key)) continue;
    if (String(value || '').trim()) return true;
  }
  return false;
};

export function installProductEventHooks() {
  if (installed) return;
  installed = true;

  axios.interceptors.response.use((response) => {
    try {
      if (!getToken()) return response;
      const method = String(response?.config?.method || 'get').toLowerCase();
      if (method !== 'get') return response;

      const url = normalizedUrl(response?.config);
      if (!url) return response;
      const path = url.pathname;
      const now = Date.now();

      // Conta apenas busca/filtro real. A carga inicial da listagem não entra.
      if (path.endsWith('/api/leiloes') && url.search && hasMeaningfulSearch(url.searchParams)) {
        const key = `${path}?${url.searchParams.toString()}`;
        if (key !== lastSearchKey || now - lastSearchAt > 5000) {
          lastSearchKey = key;
          lastSearchAt = now;
          const total = Number(response?.data?.totalLeiloes);
          postEvent('search_performed', {
            metadata: {
              query: url.searchParams.toString().slice(0, 1800),
              total_resultados: Number.isFinite(total) ? total : null,
            },
          });
        }
        return response;
      }

      // Visualização de detalhe de imóvel/leilão.
      const match = path.match(/\/api\/leiloes\/(\d+)\/?$/);
      if (match) {
        const leilaoId = Number(match[1]);
        const key = String(leilaoId);
        if (key !== lastPropertyKey || now - lastPropertyAt > 5000) {
          lastPropertyKey = key;
          lastPropertyAt = now;
          postEvent('property_viewed', { leilao_id: leilaoId });
        }
      }
    } catch { /* telemetria nunca pode quebrar a experiência */ }
    return response;
  }, (error) => Promise.reject(error));
}
